import React from 'react';
import classNames from 'classnames';
import cls from './ModalInputsDocumentInfo.module.css';
import { useModalInputsDocumentInfo } from './useModalInputsDocumentInfo';
import { Input } from '../../../../../components/newUI/Input/Input';
import { useTranslation } from 'react-i18next';

interface ModalInputsDocumentInfoProps {
    classes?: string;
    documentFormInfo: {
        documentId: string;
        documentDate: string;
    };
    onChangeInput: (documentInfoName: string, documentInfoValue: string) => void;
}

export const ModalInputsDocumentInfo = ({
    classes,
    documentFormInfo,
    onChangeInput,
}: ModalInputsDocumentInfoProps) => {
    const { t } = useTranslation();

    const { onDate } = useModalInputsDocumentInfo({ documentFormInfo, onChangeInput });
    return (
        <form className={classNames(cls.ModalInputsDocumentInfo, [classes])}>
            <div className={cls.InputDocumentInfo}>
                <Input
                    label={t('ModalInputsDocumentInfo.return.input.label')}
                    inputName={'documentId'}
                    placeholder={t('ModalInputsDocumentInfo.return.input.placeholder')}
                    onChange={onChangeInput}
                    value={documentFormInfo.documentId}
                    errorMessage={''}
                />
            </div>
            <div className={cls.InputDocumentInfo}>
                <Input
                    label={t('ModalInputsDocumentInfo.return.dateInput.title')}
                    inputName={'documentDate'}
                    placeholder={t('ModalInputsDocumentInfo.return.dateInput.placeholder')}
                    onChange={onChangeInput}
                    value={documentFormInfo.documentDate}
                    errorMessage={''}
                    classes={cls.InputDocumentInfo}
                />
            </div>
        </form>
    );
};
